import React from 'react';
import ReactDOM from 'react-dom';
import { applyMiddleware, compose, createStore } from 'redux';
import { Provider } from 'react-redux';
import loadTranslations from 'js/localeSetup';
import reduxThunk from 'redux-thunk';
import { INITIAL_DATA } from './appActions';
import Reducer from './components/reducer';
import Productpage from './productpage';
import './style.less';

const initialData = window.__INITIAL_STATE__;

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
  Reducer,
  composeEnhancers(applyMiddleware(reduxThunk))
);

store.dispatch(INITIAL_DATA(initialData));

(async () => {
  const rootElement = document.getElementById('productpage');
  await loadTranslations();

  window.scrollTo(0, 0);
  if (rootElement) {
    ReactDOM.render(
      <Provider store={store}>
        <Productpage />
      </Provider>,
      rootElement
    );
  }
})();
